<template>
    <div class="scan-qr-page">
        <div class="bg-scan">
            <div class="box-click-back" @click="clickBack()">
                <img class="ic-back" src="@/assets/icon/ic-back.svg" />
            </div>
            <div id="video-container" class="styleVideo">
                <video id="qr-video" ref="videoEl" class=""></video>
                
            </div>
            <div class="box-select-img" @click="clickUploadImg()">
                <div class="box-select">
                    <img src="@/assets/icon/ic-select-img.svg" alt="">
                    <div>{{ lbl.register.select_img }}</div>
                </div>
                <input class="input-img-profile" type="file" id="qr-input-file" accept="image/*" ref="inputFile" @change="onChangeFile($event)" />
            </div>
        </div>
    </div>
</template>
<script>
// Lib
import QrScanner from "qr-scanner";
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'ScanQr',
    mixins: [LocaleMixin],
    data: function() {
        return {
            videoEl: null,
            hasCamera: false,
            scanner: null,
            result: null,
            inputFile: null
        }
    },
    created: function() {
        this.openQrScanner();
    },
    methods: {
        openQrScanner: function () {
            QrScanner.hasCamera().then((hasDevices) => {
                if (hasDevices) {
                
                    return QrScanner.listCameras();
                } else {
                    throw new Error("can not access camera devices")
                }
            }).then((devices) => {
                if (devices && devices.length) {
                    var cameraId = devices[0].id;
                    this.$nextTick(() =>{
                        this.startScannerMode(cameraId);
                    }) 
                }
            }).catch(() => {
                // can not access camera device then go mode upload file
                this.startFileMode();
            })

        },
        startScannerMode: function () {
            this.scanner = new QrScanner(this.$refs['videoEl'], this.qrCodeSuccessCallback, {
                preferredCamera: "environment",
                highlightScanRegion: true,
                highlightCodeOutline: true,
            });
            this.scanner.setInversionMode('both');
            this.scanner.start().then(() => {
                this.hasCamera = true;
            }).catch(() => {
                this.hasCamera = false;
            })
        },
        startFileMode: function () {
            // do nothing
        },
        clickUploadImg: function () {
            this.$refs['inputFile'].click();
        },
        onChangeFile: function (ev) {
            const files = ev.target.files
            if (files.length > 0) {
                const imageFile = files[0];
                // Scan QR Code
                QrScanner.scanImage(imageFile)
                    .then(decodedText => {
                        // success, use decodedText
                        this.result = decodedText;
                        this.$emit('onDataQrCode', this.result);
                        this.stopScannerMode();
                        this.$emit('onCloseCamera', true);
                        this.clearFileInput();
                    })
                    .catch(err => {
                        // failure, handle it.
                        console.log(`Error scanning file. Reason: ${err}`);
                        this.clearFileInput();
                    })
            }
        },
        qrCodeSuccessCallback: function (decodedText) {
            this.result = decodedText.data;
            if (!this.result) return;

            this.$emit('onDataQrCode', this.result);
            this.stopScannerMode();
            this.$emit('onCloseCamera', true);
        },
        stopScannerMode: function () {
            if (this.scanner != null) {
                this.scanner.stop();
                this.scanner.destroy();
            }
        },
        clearFileInput: function () {
            this.inputFile = null;
        },

        clickBack: function (){
            if (this.hasCamera) {
                this.stopScannerMode();
            }
            this.$emit('onCloseCamera', true);
        }
    }
}
</script>
<style lang="scss">
@import "./../../../style/base/base.scss";
// #video-container {
    #qr-video {
        width: 100% !important;
        height: 100vh !important;
        height: 100svh !important; //if broswer support svh it wll use svh instant of vh
        object-fit: cover;
    }
    .styleVideo{
        background: #999 !important;
        .scan-region-highlight {
            border-radius: 30px !important;
            outline: #cccccc80 solid 50vmax !important;
            width: 285px !important;
            height: 285px !important;
            top: 0 !important;
            bottom: 0!important;
            left:  0!important;
            right: 0 !important;
            margin: auto !important;
            @media (min-width: $min-width-desktop) {
                width: 400px !important;
                height: 400px !important;
            }
            .scan-region-highlight-svg {
                stroke: #ffffff !important;
                stroke-width: 5 !important;
                stroke-dasharray: none !important;
            }
        }
    }
</style>
<style lang="scss" scoped>
.scan-qr-page {
    position: relative;
    .bg-scan {
        background-color: black;

        .box-click-back {
            position: absolute;
            top: 40px;
            left: 20px;
            z-index: 10;
        }

        .box-select-img {
            background-color: #2C2C2C;
            padding: 10px;
            border-radius: 100px;
            width: fit-content;
            position: absolute;
            bottom: 40px;
            text-align: center;
            right: 0;
            left: 0;
            margin: auto;
            z-index: 10;
            color: #ffffff;
            
            .box-select {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 8px;
            }
           
            .input-img-profile {
                display: none;
            }
        }
    }
}
</style>